import { PassKeyFAQArray } from '../../types/Passkeys/PassKeyFAQs';
export const PassKeyFAQs: PassKeyFAQArray = [
  {
    id: 1,
    isOpen: false,
    Q: 'What are passkeys?',
    A: 'A passkey allows you to log into a website using the methods you use to log into your device, such as FaceID, TouchID, the Android fingerprint reader, Windows Hello, and more. When you visit a website you will be prompted for a PIN, face or fingerprint instead of a password. Behind the scenes, your device is generating a cryptographic signature that is sent to the website. Your biometric data always stays secure on your device.',
  },
  {
    id: 2,
    isOpen: false,
    Q: 'Do I have a passkey?',
    A: "If you have a device that supports biometric authentication, you have a passkey. If you don't have a device that supports biometric authentication, you can still use a passkey by setting up a PIN on your device.",
  },
  {
    id: 3,
    isOpen: false,
    Q: "What if I don't have an iPhone?",
    A: 'Apple is at the forefront of building passkeys that can be synced between devices (via your iCloud account), but you can get a similar experience on any biometric-compatible device with Passage. When a device does not have a biometric reader or PIN enabled, Passage falls back to a text or email link, so users on any device can access their accounts.',
  },
  {
    id: 4,
    isOpen: false,
    Q: 'Is passwordless authentication secure and private?',
    A: "Yes. Passwordless authentication is more secure than passwords because it's harder for attackers to steal your biometric data than it is to steal your password. Your biometric data is stored on your device and never leaves it. It's also private because your biometric data is never shared with the website you're logging into.",
  },
  {
    id: 5,
    isOpen: false,
    Q: 'Can I share accounts with my family?',
    A: 'Yes! Apple supports sharing passkeys between iCloud accounts. When you share a passkey with someone else, they will be able to seamlessly log in to the website from any device that has their iCloud account on it.',
  },
  {
    id: 6,
    isOpen: false,
    Q: "What if I don't want to use a passkey?",
    A: "Though we don't recommend it for security reasons, you can request a code be sent to your email address. This code expires ten minutes from the time it is sent. If you logout you can request additional codes be sent to the same email address.",
  },
  {
    id: 6,
    isOpen: false,
    Q: 'Why do you still need my email address?',
    A: 'Email addresses are required for account creation, recovery, and to send you notifications about your account. We will never sell your email address to third parties.',
  },
  {
    id: 7,
    isOpen: false,
    Q: 'I created my account a while ago. What do I do?',
    A: 'You will be able to log in with the Legacy Account button on the next screen. If you have any trouble, or would like to upgrade your security, please contact support.',
  },
];
